module.exports = __webpack_public_path__ + "img/hero-lg.af2d7fc4.png";